// this file defines both the backend api type (snake_case) and the frontend type (camelCase)
// always use IAiModel (camelCase) in the frontend, and convert from IAiModelApi at the api boundary
import { SATOSHIS } from 'lib/bsv-util'

// snake_case type for backend api
export interface IAiModelApi {
    id: string
    name: string
    usd_cost: number
    model_type: 'image' | 'video' | 'text' | 'audio'
    usd_treechat_private_price: number
    provider: string
    created_at?: string
    updated_at?: string
    action_tag_name: string
    usd_treechat_public_price: number
    can_remix_video?: boolean
    can_remix_image?: boolean
}

// camelCase type for frontend
export interface IAiModel {
    id: string
    name: string
    usdCost: number
    modelType: 'image' | 'video' | 'text' | 'audio'
    usdTreechatPrivatePrice: number
    provider: string
    createdAt?: string
    updatedAt?: string
    actionTagName: string
    usdTreechatPublicPrice: number
    humanName: string
    description: string
    canRemixVideo?: boolean
    canRemixImage?: boolean
}

// hardcoded mapping from api to camelcase
export function apiModelToCamel(api: IAiModelApi): IAiModel {
    return {
        id: api.id,
        name: api.name,
        usdCost: api.usd_cost,
        modelType: api.model_type,
        usdTreechatPrivatePrice: api.usd_treechat_private_price,
        provider: api.provider,
        createdAt: api.created_at,
        updatedAt: api.updated_at,
        actionTagName: api.action_tag_name,
        usdTreechatPublicPrice: api.usd_treechat_public_price,
        humanName: (api as any).human_name,
        description: (api as any).description,
        canRemixVideo: api.can_remix_video,
        canRemixImage: api.can_remix_image,
    }
}

// type for ui defaults for ai models (camelCase)
export type AiModelUIDefault = {
    actionTagName: string
    humanName: string
    description: string
}

export function findModelByActionTag(
    aiModels: IAiModel[],
    actionTag: string,
): IAiModel | undefined {
    return aiModels.find(model => model.actionTagName === actionTag)
}

export function getPublicModelCost(model: IAiModel | undefined): number {
    return model?.usdTreechatPublicPrice ?? 0
}

export function getPrivateModelCost(model: IAiModel | undefined): number {
    return model?.usdTreechatPrivatePrice ?? 0.1
}
export function usdToSats(usdAmount: number, exchangeRate: number | null): number | null {
    if (!exchangeRate) return null
    return Math.round((usdAmount / exchangeRate) * SATOSHIS)
}
